import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

function extractFailure(response, fallback) {
    if (response && response.code === "FAILURE") {
        return response.message || fallback;
    }
    return null;
}

const TagMigrationService = {
    list: async (language) => {
        try {
            const lang = typeof language === "string" ? language.trim() : "";
            const qs = lang ? `?language=${encodeURIComponent(lang)}` : "";
            const response = await ApiService.getData(`/v1/system/tag-migration${qs}`);
            const fail = extractFailure(response, "Failed to load tags");
            if (fail) return { success: false, error: fail, data: [] };
            const tags = Array.isArray(response?.tags) ? response.tags : [];
            return { success: true, data: tags };
        } catch (e) {
            Logger.error("TagMigrationService.list:", e);
            return { success: false, error: e.message || "Failed to load tags", data: [] };
        }
    },

    rename: async (fromTag, toTag, sources, language) => {
        try {
            const response = await ApiService.postData("/v1/system/tag-migration/rename", {
                fromTag,
                toTag,
                sources,
                language: typeof language === "string" ? language.trim() : "",
            });
            const fail = extractFailure(response, "Failed to rename tag");
            if (fail) return { success: false, error: fail };
            return { success: true, data: response };
        } catch (e) {
            Logger.error("TagMigrationService.rename:", e);
            return { success: false, error: e.message || "Failed to rename tag" };
        }
    },

    listStories: async (tag, source, language) => {
        try {
            const lang = typeof language === "string" ? language.trim() : "";
            const qs = [
                `tag=${encodeURIComponent(String(tag || "").trim())}`,
                `source=${encodeURIComponent(source || "JIGSAW")}`,
                lang ? `language=${encodeURIComponent(lang)}` : "",
            ].filter(Boolean).join("&");
            const response = await ApiService.getData(`/v1/system/tag-migration/stories?${qs}`);
            const fail = extractFailure(response, "Failed to load stories");
            if (fail) return { success: false, error: fail, data: [] };
            const stories = Array.isArray(response?.stories) ? response.stories : [];
            return { success: true, data: stories };
        } catch (e) {
            Logger.error("TagMigrationService.listStories:", e);
            return { success: false, error: e.message || "Failed to load stories", data: [] };
        }
    },
};

export default TagMigrationService;
